import type { ChartDataPoint } from '../../types/charts.ts';

/**
 * Sample datasets for chart demos and testing.
 */

export const donutSample: ChartDataPoint[] = [
  { category: 'Eligible', value: 42 },
  { category: 'In Progress', value: 28 },
  { category: 'Completed', value: 18 },
  { category: 'Not Started', value: 12 },
];

export const barSample: ChartDataPoint[] = [
  { category: 'Jan', value: 120 },
  { category: 'Feb', value: 185 },
  { category: 'Mar', value: 210 },
  { category: 'Apr', value: 165 },
  { category: 'May', value: 240 },
  { category: 'Jun', value: 290 },
];

export const horizontalBarSample: ChartDataPoint[] = [
  { category: 'Computer Science', value: 450 },
  { category: 'Business Administration', value: 380 },
  { category: 'Nursing', value: 310 },
  { category: 'Engineering', value: 275 },
  { category: 'Education', value: 220 },
  { category: 'Psychology', value: 185 },
  { category: 'Biology', value: 150 },
  { category: 'Communications', value: 120 },
];

export const lineSample: ChartDataPoint[] = [
  { category: 'Q1 2024', value: 1200 },
  { category: 'Q2 2024', value: 1850 },
  { category: 'Q3 2024', value: 2100 },
  { category: 'Q4 2024', value: 1950 },
  { category: 'Q1 2025', value: 2400 },
  { category: 'Q2 2025', value: 2800 },
];

export const areaSample: ChartDataPoint[] = [
  { category: 'Mon', value: 45 },
  { category: 'Tue', value: 52 },
  { category: 'Wed', value: 49 },
  { category: 'Thu', value: 63 },
  { category: 'Fri', value: 58 },
  { category: 'Sat', value: 32 },
  { category: 'Sun', value: 28 },
];

export const pieSample: ChartDataPoint[] = [
  { category: 'Federal Loans', value: 55 },
  { category: 'Private Loans', value: 25 },
  { category: 'Grants', value: 15 },
  { category: 'Scholarships', value: 5 },
];

export const summarySample: ChartDataPoint[] = [{ category: 'Employees', value: 12847 }];

export const largeSample: ChartDataPoint[] = Array.from({ length: 20 }, (_, i) => ({
  category: `Item ${i + 1}`,
  value: Math.round(Math.random() * 500 + 50),
}));

export const smallSample: ChartDataPoint[] = [
  { category: 'A', value: 30 },
  { category: 'B', value: 70 },
];
